module.exports = "img/flags/CI.f0a4a32.png";